<script>
const urlPattern = /(https?:\/\/[^<>\s\r\n\t]+)/g;

export default {
  name: "vc-share-auto-linked-text",
  render(createElement) {
    return createElement(
      "span",
      this.getAutoLInkedTextElement(this.$slots.default, createElement)
    );
  },
  props: {
    linkOptions: {
      type: Object,
      default: () => ({
        target: "_self"
      })
    }
  },
  methods: {
    getAutoLInkedTextElement(elements, createElement) {
      return elements.map(node => {
        if (node.children) {
          return createElement(
            node.tag,
            node.data,
            this.getAutoLInkedTextElement(node.children, createElement)
          );
        } else if (node.text) {
          const splitText = node.text.split(urlPattern);
          if (splitText.length > 1) {
            return splitText.map(text => {
              if (urlPattern.test(text)) {
                return createElement(
                  "vc-share-a",
                  { props: { ...this.linkOptions, href: text } },
                  text
                );
              } else {
                return text;
              }
            });
          }
        }
        return node;
      });
    }
  }
};
</script>
